import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginPrincipalContainerModel} from '../../../../../models/aggregates/app-login';


@Injectable({
  providedIn: 'root'
})
export class IdentityAccessKeyService extends BaseApiTemplateService<AppLoginPrincipalContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/access-keys';
    this.httpClient = http;
  }

}
